import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const AUTH_API = environment.APIEndpoint + '/api/auth/';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private http: HttpClient) { }

  getUserRoles(userId: string): Observable<any> {
    return this.http.get(AUTH_API + 'users/' + userId + '/roles', httpOptions);
  }

  // Le back répond en texte brut ("Rôle ajouté" / message d'erreur), pas en JSON
  addRole(userId: string, roleName: string): Observable<any> {
    return this.http.put(AUTH_API + 'users/' + userId + '/add-role?roleName=' + roleName, {},
      {...httpOptions, responseType: 'text'});
  }

  removeRole(userId: string, roleName: string): Observable<any> {
    return this.http.put(AUTH_API + 'users/' + userId + '/remove-role?roleName=' + roleName, {},
      {...httpOptions, responseType: 'text'});
  }
}
